import { RootState } from 'app/store/rootReducer';
import {
  InsuranceTypeEnum,
  ShortPathTypeEnum,
  VehicleTypeEnum,
} from 'app/shared/enums';
import { hasPersistedMerchOrderData } from 'app/shared/helpers/hasPersistedMerchOrderData';

export const selectQuotation = (state: RootState) => state.quotation;
export const getQuotationId = (state: RootState) => state.quotation.id;
export const getQuotationStatus = (state: RootState) => state.quotation.status;
export const getQuotationNumber = (state: RootState) => state.quotation.number;
export const getQuotationEmailAddress = (state: RootState) =>
  state.quotation.emailAddress;
export const selectIsMotorcycle = (state: RootState) =>
  state.quotation.vehicleType === VehicleTypeEnum.Motorcycle;

export const selectGtmVehicleType = (state: RootState) =>
  selectIsMotorcycle(state)
    ? 'Ubezpieczenie motocykla'
    : 'Ubezpieczenie samochodu';

export const getSelectedInsuranceScope = (
  state: RootState
): Array<InsuranceTypeEnum> =>
  state.quotation.scope === undefined || state.quotation.scope === null
    ? []
    : state.quotation.scope.components;

export const getQuotationOfferFilters = (state: RootState) =>
  state.quotation.offerFilters;

export const getCoownersCount = (state: RootState) =>
  state.quotation.coOwnersCount
    ? +state.quotation.coOwnersCount.replace('_', '')
    : 0;

export const getQuotationPhoneNumber = (state: RootState) =>
  state.quotation.phoneNumber;

export const getCarProductionYear = (state: RootState): number | undefined => {
  const car = state.quotation.car;

  if (car) {
    return car.productionYear;
  }
};

export const getCarMake = (state: RootState): string | undefined => {
  const car = state.quotation.car;

  if (car) {
    return car.make;
  }
};

export const getCarModel = (state: RootState): string | undefined => {
  const car = state.quotation.car;

  if (car) {
    return car.model;
  }
};

export const selectCarVersionEt = (state: RootState): string | undefined => {
  const car = state.quotation.car;

  if (car) {
    return car.versionEt;
  }
};

export const selectCarRegistrationNumber = (
  state: RootState
): string | undefined => {
  const car = state.quotation.car;

  if (car) {
    return car.registrationNumber;
  }
};

export const selectIsPersonalDataPath = (state: RootState) => {
  return state.quotation.personalDataPath;
};

export const selectQuotationPayment = (state: RootState) => {
  return state.quotation.payment;
};

export const selectQuotationActiveAbTests = (state: RootState) => {
  return state.quotation.activeABTests;
};

export const selectMerchOrder = (state: RootState) =>
  state.quotation.merchOrder;

export const selectIsMerchCapSelected = (state: RootState) =>
  state.quotation.merchOrder?.selected === true ||
  hasPersistedMerchOrderData(state.quotation.merchOrder);

export const selectQuotationCepikMergeResult = (state: RootState) => {
  return state.quotation.cepikMergeResult;
};

export const selectQuotationOwnerBirthDate = (state: RootState) => {
  return state.quotation.mainOwner?.birthDate;
};

export const selectIsRenewal = (state: RootState) => {
  return !!(state.quotation.renewal || state.quotation.externalRenewal);
};

export const selectIsRegulationsConsentAccepted = (state: RootState) =>
  state.quotation.consents?.regulations?.consent === true;

export const selectIsCepik3ShortPath = (state: RootState) =>
  state.quotation.shortPath?.shortPathBasedOn === ShortPathTypeEnum.Cepik3;
